
import { dealFixQuery, dealScreenValue } from '@/components/schoolInstrument/component/mutual/common/config.js'
import { getfielddatalist } from '@/port/admins/mutual.js'
import { getopenreportformlist } from '@/port/clientSide/workbench.js'
import { apiGetapprovalreport } from '@/port/admins/report.js'
import { apiGetapprovaldashboardpreviewNoDate } from '@/port/admins/instrument.js'
import { cloneDeep } from 'lodash'
import { getapprovalfieldoptions } from '@/port/admins/instrument.js'
import $store from "@/store/index.js"
import { setConfigCustomData } from '@/util/customData.js'
import { dealText } from '@/api/common.js'
import { setCustomData } from '@/util/customData'

// 获取当前级的数据
export const getData = async (val) => {
  const { config = {}, isOptions = false, totalParams = {}, loadingLevel = 'all', levelType = '', fatherData = {}, customDeskId = 0, customData,pageSize = 3000, screenRefValue = [] } = val
  // level 表示是多级筛选树的第几层 第一层时直接调用
  // fatherData 父级的值
  // screenRefValue 所有筛选组件的值
  const { dataInfo, field, isMoreFiled } = config
  let resultValue = []
  if (!field) return resultValue
  const title = dataInfo.datatype === 1 ? field.split('_')[0] : field.split('_')[1] // 当前表要使用的字段
  const type = field.split('_')[2] // 当前表要使用字段的类型
  // 直接在一级的时候走这个接口（数据量大的情况）
  // 单级多字段要走全部数据获取
  if (loadingLevel === 'one' || (levelType === 'single' && !isMoreFiled)) {
    const list = await getAppOptions(config, customDeskId, customData, pageSize, screenRefValue) || []
    resultValue = list.map(item => {
      const obj = {
        [title]: item
      }
      return { ...fatherData, ...obj }
    })
  } else {
    if (dataInfo.datatype === 1) {
      resultValue = await getAppData(config, isOptions, totalParams, customDeskId, customData, screenRefValue, pageSize)
    } else {
      resultValue = await getReportData(config, customDeskId, customData, screenRefValue)
    }
    if (type === 'checkbox') {
      const tempResultValue = []
      resultValue.forEach(item => {
        if (item[title].length > 0) {
          if (item[title].length === 1) {
            // 只有一个选项直接赋值就好了
            tempResultValue.push(item)
          } else {
            // 多个选项给他拆成一条一条的数据
            const _item = cloneDeep(item)
            item[title].forEach(iter => {
              _item[title] = iter
              tempResultValue.push(cloneDeep(_item))
              return _item
            })
          }
        }
      })
      resultValue = tempResultValue
    } else if (type === 'relation-user') {
      // 处理一下单有多个联系人的情况
      const tempUserArr = []
      resultValue.forEach(item => {
        if (Array.isArray(item[title])) {
          item[title].forEach(user => {
            const obj = cloneDeep(item)
            obj[title] = [user]
            tempUserArr.push(obj)
          })
        }
      })
      resultValue = tempUserArr
    }
  }
  return resultValue
}
export const getAppData = async ({ dataInfo, rulerData, field }, isOptions, totalParams, customDeskId, customData, screenRefValue = [], pageSize = 3000) => {
  const { query } = totalParams
  const obj = {
    approvalId: dataInfo.id,
    pagesize: 1,
    curpage: 0
  }
  const { data } = await getopenreportformlist(obj)
  const param = {
    type: 0,
    curpage: 0,
    pagesize: isOptions ? 1 : pageSize,
    approvalId: dataInfo.id,
    reportFormId: data[0].reportFormId
  }
  if (Array.isArray(rulerData.fixorder) && rulerData.fixorder) {
    param.fixorder = rulerData.fixorder
  }
  if (rulerData.fixquery) {
    param.fixquery = dealFixQuery(rulerData.fixquery, customData, customDeskId, screenRefValue)
    if (param.fixquery.noSearch) {
      // 符合无数据不查找的情况
      return []
    }
  }
  if (isOptions) {
    let name = `${field.split('_')[0]}_${field.split('_')[2]}`
    if (field.split('_')[0] === '状态' || field.split('_')[0] === 'status') {
      name = 'status_status'
    }
    param.groupfield = name
    if (query) {
      param.query = query
    }
  }
  const res = await getfielddatalist(param)
  return res.data
}
export const getReportData = async ({ dataInfo, rulerData }, customDeskId, customDataPayLoad, screenRefValue = []) => {
  let resultValue = []
  const res = await apiGetapprovalreport({ approvalReportId: dataInfo.id }).catch(e => { console.log(e) })
  if (res.code === 0) {
    const config = JSON.parse(res.data.config)
    const variableconfig = res.data.variableconfig ? JSON.parse(res.data.variableconfig) : []
    const allData = dataInfo.allData
    const submitdatas = []
    // 数据源字段
    const outputItem = config.find(item => { return item.type === 'output' })
    if (outputItem) {
      const outputObj = {
        type: 'source',
        dataconfig: {
          reportid: dataInfo.id,
          fields: outputItem.dataconfig.out.fields,
          select: outputItem.dataconfig.out.select
        },
        approvalId: dataInfo.id,
        id: 1
      }
      submitdatas.push(outputObj)
    }
    // 数据过滤节点
    // 处理传参值
    let noSearch = false
    const linked = (Array.isArray(rulerData.fixquery.linked) ? rulerData.fixquery.linked : []).map(item => {
      if (item.conditionValue && Array.isArray(item.conditionValue)) {
        const _conditionValue = cloneDeep(item.conditionValue)
        _conditionValue.forEach((iter, index) => {
          if (iter.datatype === 'custom') {
            item.conditionValue[index] = '${' + iter.name + '}'
          }
        })
        // 无数据不查找
        if (item.noSearch && item.conditionValue.length === 0) {
          noSearch = true
        }
      }
      const screenValue = dealScreenValue(item, screenRefValue)
      if (Array.isArray(screenValue) && screenValue.length > 0) {
        Array.isArray(item.conditionValue) ? item.conditionValue.push(...screenValue) : item.conditionValue = screenValue
      }
      return item
    })
    // 无数据不查找
    if (noSearch) return []
    rulerData.fixquery.linked = linked
    const filter = rulerData.fixquery
    filter.rel = filter.ov
    delete filter.ov
    // - 数据筛选数据转换
    if (Array.isArray(filter.linked) && filter.linked.length > 0) {
      // - 公式字段提交数据生成
      filter.where = filter.linked.map(item => {
        const val = item.type === 'relation-user' ? item.conditionValue && item.conditionValue.map(iter => { return iter.realname }) : item.conditionValue
        const obj = {
          field: item.name,
          relation: item.condition,
          value: val || []
        }
        if (item.condition === 'curuser') {
          obj.value = []
        }
        return obj
      })

      submitdatas.push({
        type: 'filter',
        dataconfig: filter,
        parentid: [1], // - 与上一级id保持一致
        id: 2
      })
    }
    // - 排序数据转换
    let sort = rulerData.fixorder
    if (Array.isArray(sort) && sort.length > 0) {
      sort = sort.map(item => {
        const index = allData.findIndex(iter => { return iter.fatherType === item.feild })
        if (index !== -1) {
          item.feild = allData[index].name
        }
        return item
      })
      submitdatas.push({
        type: 'orders',
        dataconfig: {
          orderby: [...sort]
        },
        parentid: [2], // - 与上一级id保持一致
        id: 3
      })
    }
    const index = submitdatas.length
    const nodeId = submitdatas[index - 1].id
    const obj = {
      curpage: 0,
      pagesize: 3000,
      config: submitdatas,
      nodeId
    }
    const customData = (customDataPayLoad ? customDataPayLoad : ( customDeskId ? $store.state.doorCustomDataObj[customDeskId] : $store.state.doorCustomData)) || []
    if (variableconfig.length > 0) {
      customData.push(...variableconfig)
    }
    if (customData.length > 0) {
    // 存在$就是自定义的变量
      const _customData = {}
      const customDataList = await setConfigCustomData(cloneDeep(customData))
      customDataList.map(item => {
        let val = item.value
        if (item.type === 'relation-user' && val.length > 0) {
          val = val.map(iter => {
            return {
              realname: iter.realname,
              userId: iter.userId
            }
          })
          // val = JSON.stringify(val)
        } else if (item.type === 'text' && val && val.search('{') !== -1) {
          const res = dealText({
            text: val,
            commonData: $store.state.userData,
            customData: customDataList,
            functionParms: item.functionParms || []
          })
          val = res || val
        }
        _customData[item.name] = val
      })
      obj.customData = _customData
    }
    const { data } = await apiGetapprovaldashboardpreviewNoDate(obj)
    resultValue = data
  }
  return resultValue
}
export const getAppOptions = async (config, customDeskId, customData, pageSize, screenRefValue = []) => {
  const { field, dataInfo, rulerData } = config
  const title = dataInfo.datatype === 1 ? field.split('_')[0] : field.split('_')[1] // 当前表要使用的字段
  const type = field.split('_')[2]
  let val = `${title}_${type}`
  if (title === 'orders') {
    val = '单号_text'
  }
  const _field = dataInfo.allData.filter(item => { return val === `${item.title}_${item.type}` })
  if (_field.length > 0 && field[0].fatherType) {
    val = _field[0].fatherType
  }
  const isShop = (dataInfo.datatype === 4 || dataInfo.datatype === 2)
  const param = {
    curpage: 1,
    pagesize: pageSize || 3000,
    text: '',
    title: isShop ? title : val,
    approvalId: isShop ? 0 : dataInfo.id,
    reportId: isShop ? dataInfo.id : 0
  }
  if (isShop) {
    dataInfo.variableconfig = typeof dataInfo.variableconfig === 'string' ? JSON.parse(dataInfo.variableconfig) : dataInfo.variableconfig
  }
  if (rulerData) {
    const { query, order, noSearch } = delRulerData(
      cloneDeep(rulerData),
      customDeskId,
      customData,
      isShop,
      dataInfo.allData || [],
      screenRefValue,
      dataInfo.variableconfig || []
    )
    // 符合无数据的情况直接返回空值
    if (noSearch) {
      return []
    }
    if (query && query.length > 0) {
      param.query = query
      param.rel = rulerData.fixquery.ov || 'and'
    }
    if (order && order.length > 0) {
      param.order = order
    }
  }
  if (dataInfo.variableconfig) {
    const customDataList = await setConfigCustomData(cloneDeep(dataInfo.variableconfig))
    param.customData = setCustomData(customDataList)
  }
  let { data } = await getapprovalfieldoptions(param)
  if (type === 'checkbox') {
    data = data.reduce((prev, curr) => prev.concat(curr), [])
  } else if (type === 'relation-user') {
    const userList = []
    data.forEach(item => {
      if (Array.isArray(item) && item.length > 0) {
        userList.push(...item)
      }
    })
    data = userList.filter((contact, index, array) => {
      // 检查当前 ID 是否是第一次出现
      return index === array.findIndex(item => item.userId === contact.userId);
    }).map(item => {
      // 配合外部统一处理数据就这样改
      return [item]
    })
  }
  data = data.filter(item => { if (item || item === 0) return item })
  return data || []
}
// 处理过滤格式
export const delRulerData = (rulerData, customDeskId, _customData, isShop = false, allData = [], screenRefValue = [], variableconfig = []) => {
  const resultValue = { query: [], order: [] }
  if (rulerData) {
    if (rulerData.fixquery && rulerData.fixquery.linked && rulerData.fixquery.linked.length > 0) {
      let customData = []
      if (_customData && _customData.length > 0) {
        customData = _customData
      } else {
        customData = customDeskId ? $store.state.doorCustomDataObj[customDeskId] : $store.state.doorCustomData
      }
      resultValue.query = rulerData.fixquery.linked.map(item => {
        const obj = {
          field: isShop ? item.name : `${item.title}_${item.type}`,
          value: (item.conditionValue || []).map(iten => {
            let val = iten
            if (typeof iten === 'object' && iten.datatype === 'custom') {
              const i = customData.findIndex(iter => { return iter.name === iten.name })
              if (i !== -1) {
                val = customData[i].value
              } else {
                val = ''
              }
            }
            return val
          }).filter(iten => { return iten || iten === 0 }) || [],
          relation: item.condition
        }
        const screenValue = dealScreenValue(item, screenRefValue)
        if (Array.isArray(screenValue) && screenValue.length > 0) {
          obj.value.push(...screenValue)
        }

        // 过滤字段如果是联系人的话 只有in 和noin,但是设置不止这几个 后端不愿意改 这边给他转换成这两条件
        if (item.type === 'relation-user') {
          const inArr = ['curuser', 'qtUser', 'eq']
          const noin = ['nQtUser', 'neq']
          if (obj.value.length > 0 && Array.isArray(obj.value[0])) {
            obj.value = obj.value[0]
          }
          if (inArr.includes(item.condition)) {
            obj.relation = 'in'
            if (item.condition === 'curuser') {
              // curuser为等于当前用户
              let userMsg = localStorage.getItem('userMsg')
              if (userMsg) {
                userMsg = JSON.parse(userMsg)
                const user = {
                  userId: userMsg.userId,
                  realname: userMsg.realname
                }
                obj.value = [user]
              }
            }
          } else if (noin.includes(item.condition)) {
            obj.relation = 'noin'
          }
        }
        // 如果传入的是变量就不要加到过滤条件里面了
        if (item.datatype === 'custom') {
          const variableItem = variableconfig.find(iten => { return iten.title === item.title })
          if (variableItem) {
            variableItem.value = obj.value
          }
          return null
        } else {
          // 无数据不查找
          if (item.noSearch && (!obj.value || obj.value.length === 0)) {
            resultValue.noSearch = true
          }
          return obj
        }
      }).filter(item => { return item })
    }
    if (rulerData.fixorder && rulerData.fixorder.length > 0) {
      resultValue.order = cloneDeep(rulerData.fixorder).map(item => {
        if (isShop) {
          const index = allData.findIndex(iten => { return `${iten.title}_${iten.type}` === item.feild })
          if (index !== -1) {
            item.feild = allData[index].name
          }
        }
        return item
      })
    }
  }
  return resultValue
}


export const statusMap = {
  0: '待审批',
  1: '已通过',
  2: '未通过',
  3: '已撤回'
}

export const formatOrg = (list = []) => {
  return list.map(item => ({ organizationId: item.organizationId, name: item.name, looktype: item.looktype || 0, type: item.type }))
}

export const formatRole = (list = []) => {
  return list.map(item => ({ roleId: item.roleId, name: item.name }))
}

export const getFileterList = async (param) => {
  const res = await getapprovalfieldoptions(param)
  if (res.code === 0) {
    return res.data.flat()
  }
}
